module.exports = __webpack_public_path__ + "img/marker4.712f1f57.png";